import React from 'react';

import './CompanyName.less';

export function CompanyName({ companyName }: { companyName: string }): JSX.Element {
  return (
    <p className="company_name">{`Asked by ${companyName}`}</p>
  );
}

export default CompanyName;
